import axios from "axios";
import {
  handleSuccessOne,
  handleErrorOne,
  toISOLocal,
} from "@store/action/GlobalAction";
import { cancel_playlist_at, change_playlist_at } from "../radio/RadioAction";
import { insertThread } from "../chat/GroupAction";

const REACT_APP_MANAGE_USERS = process.env.REACT_APP_MANAGE_USERS;
const URL = process.env.REACT_APP_MICRO_PLANING_URL;
const radio_id = localStorage.getItem("radio_id");
const REACT_APP_INVITATION_LINK = process.env.REACT_APP_INVITATION_LINK;

export const getAllEpisodes = (params) => async (dispatch) => {
  await axios
    .get(`${URL}/episode/${params?.per_page}?page=${params?.page}`)
    .then((response) => {
      dispatch({
        type: "GET_ALL_EPISODES",
        data: response.data.data,
        allData: response.data.data,
        totalPages: response.data.data.total,
        params,
      });
    });
};
export const GetAllEpisodesByTypeId = (type_id, params) => (dispatch) => {
  axios
    .get(
      `${URL}/episodes/type/${type_id}/radio/pagination/${params?.per_page}?page=${params?.page}`
    )
    .then((response) => {
      dispatch({
        type: "GET_All_EPISODES_BY_TYPEID",
        data: response.data.data,
        total: response.data.data?.total,
      });
    });
};

export const getEpisode = (id) => async (dispatch) => {
  await axios
    .get(`${URL}/episodes/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_EPISODE",
        selectedEpisodes: response.data.data,
      });
    })
    .catch((err) => console.log("err getEpisode", err.response));
};
export const getEpisodeByEmission =
  (status_id, emission_id) => async (dispatch) => {
    await axios
      .get(`${URL}/episode/emission/${emission_id}/status/${status_id}`)
      .then((response) => {
        dispatch({
          type: "GET_EPISODES_EMISSION_ID",
          data: response.data.data,
        });
      });
  };

export const sendNotifications = (episode_id) => {
  const pageUrl = window.location;
  const link = `${pageUrl.origin}${REACT_APP_INVITATION_LINK}/${radio_id}${episode_id}/{userid}`;
  axios.post(`${URL}/episodes/guest/sendinvitation`, {
    episode_id,
    link,
  });
};
export const cancelNotifications = (user_id) => {
  axios.patch(`${REACT_APP_MANAGE_USERS}/users/${user_id}/cancelinvitation`);
};

export const addEpisode = (episode, func, recordUrl, params) => (dispatch) => {
  dispatch({
    type: "FETCH_DATA_LOADING",
  });
  axios
    .post(`${URL}/episodes/Addrecurrence`, episode)
    .then((res) => {
      dispatch({
        type: "ADD_EPISODE_SUCCESS",
        episode,
      });
      func();
      dispatch(getAllEpisodes(params));
      dispatch(
        GetAllEpisodesByTypeId(res.data.data[0].episode_type_id, params)
      );
      return res;
    })
    .then(async (res1) => {
      for (let index = 0; index < res1.data.data.length; index++) {
        const element = res1.data.data[index];
        element.episode_type_id == 1 && sendNotifications(element.id);
        element.episode_type_id == 1
          ? await dispatch(
              insertThread({
                subject: element.name,
                type: 2,
                episode: element.id,
                is_group: false,
                lockout: true,
                radio: parseInt(radio_id),
              })
            )
          : change_playlist_at({
              radio_id: element.radio_id,
              playlist_url: recordUrl(),
              time_sec: element.duration_sec,
              started_at: toISOLocal(
                new Date(element.episode_schedule[0].start_datetime)
              ),
              episode_id: element.id,
              episode_type_id: element.episode_type_id,
              action: "post",
            });
      }
      handleSuccessOne(res1.data.message);
    })
    .catch((err) => {
      if (err.response.data.message) {
        dispatch({
          type: "ADD_EPISODE_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "ADD_EPISODE_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const editEpisode =
  (episode, func, chancelPls, recordUrl, params) => async (dispatch) => {
    const datas = new FormData();
    datas.append("name", episode.name);
    datas.append("description", episode.description);
    datas.append("classification_id", episode.classification_id);
    datas.append("duration_sec", episode.duration_sec);
    datas.append("emission_id", episode.emission_id);
    datas.append("episode_type_id", episode.episode_type_id);
    datas.append("start_datetime", episode.start_datetime);
    datas.append("is_live", 1);
    datas.append("is_recorded", 1);
    datas.append("has_reactions", 1);
    datas.append("has_live_chat", 1);
    datas.append("is_radio_policy", 1);
    episode.episode_type_id == 1 &&
      datas.append("animator_id", episode.animator_id);
    episode.episode_type_id == 2 &&
      datas.append("playlist_id", episode.playlist_id);
    episode.episode_type_id == 3 && datas.append("rush_id", episode.rush_id);
    episode.episode_type_id == 4 &&
      datas.append("podcast_id", episode.podcast_id);
    datas.append("radio_id", episode.radio_id);
    datas.append("is_recurrence", episode.is_recurrence);

    if (episode.background_img !== null) {
      datas.append("background_img", episode.background_img);
    }

    for (let index = 0; index < episode.columnist_ids?.length; index++) {
      const element = episode.columnist_ids[index];
      datas.append("columnist_ids[]", element);
    }
    for (let index = 0; index < episode.guest_ids?.length; index++) {
      const element = episode.guest_ids[index];
      datas.append("guest_ids[]", element);
    }

    for (let index = 0; index < episode.categorie_ids?.length; index++) {
      const element = episode.categorie_ids[index];
      datas.append("categorie_ids[]", element);
    }
    for (let index = 0; index < episode.tag_ids?.length; index++) {
      const element = episode.tag_ids[index];
      datas.append("tag_ids[]", element);
    }
    datas.append("_method", "PUT");
    dispatch({
      type: "FETCH_DATA_LOADING",
    });
    axios
      .post(`${URL}/episodes/${episode.id}`, datas)
      .then((res) => {
        dispatch({
          type: "EDIT_EPISODE_SUCCESS",
          datas,
        });
        func();
        handleSuccessOne(res.data.message);
        dispatch(getAllEpisodes(params));
        dispatch(GetAllEpisodesByTypeId(episode.episode_type_id, params));
        dispatch(getEpisode(episode.id));
        episode.episode_type_id == 1 && sendNotifications(episode.id);
      })
      .then(() => episode.episode_type_id !== 1 && chancelPls())
      .then(
        () =>
          episode.episode_type_id !== 1 &&
          change_playlist_at({
            radio_id: parseInt(episode.radio_id),
            playlist_url: recordUrl(),
            time_sec: episode.duration_sec,
            started_at: toISOLocal(new Date(episode.start_datetime)),
            episode_id: episode.id,
            episode_type_id: episode.episode_type_id,
            action: "edit",
          })
      )
      .catch((err) => {
        dispatch({
          type: "EDIT_EPISODE_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT_EPISODE_FAIL",
            payload: null,
          });
        }, 3000);
      });
  };
export const deleteEpisode =
  (id, episode_type_id, x, y, params) => (dispatch) => {
    axios
      .delete(`${URL}/episodes/${id}`)
      .then((res) => {
        if (res.data.code === 200) {
          handleSuccessOne(res.data.message);
          dispatch(getAllEpisodes(params));
          dispatch(GetAllEpisodesByTypeId(episode_type_id, params));
        }
      })
      .then(() => {
        x && cancel_playlist_at({ x, y });
      })
      .catch((err) => {
        if (err.response) {
          handleErrorOne(err.response.data.message);
        }
      });
  };
export const deleteEpisodeRecurrence =
  (id, episode_type_id, x, y, params) => (dispatch) => {
    axios
      .delete(`${URL}/episodes/DeleteAllRecurrence/${id}`)
      .then((res) => {
        if (res.data.code === 200) {
          handleSuccessOne(res.data.message);
          dispatch(getAllEpisodes(params));
          dispatch(GetAllEpisodesByTypeId(episode_type_id, params));
        }
      })
      .then(() => {
        x && cancel_playlist_at({ x, y });
      })
      .catch((err) => {
        if (err.response) {
          handleErrorOne(err.response.data.message);
        }
      });
  };
export const getEpisodeTypes = () => async (dispatch) => {
  await axios.get(`${URL}/episodeTypes`).then((response) => {
    dispatch({
      type: "GET_ALL_EPISODES_TYPES",
      episodesTypes: response.data.data,
    });
  });
};
export const getEpisodesByWeek = () => async (dispatch) => {
  await axios.get(`${URL}/episode/week/radio`).then((response) => {
    dispatch({
      type: "GET_EPISODES_BY_WEEK",
      data: response.data.data,
    });
  });
};
export const extendEpisode = (id, data, func) => async (dispatch) => {
  await axios
    .put(`${URL}/episode/extend/${id}`, data)
    .then((res) => {
      dispatch({
        type: "EXTEND_EPISODE_SUCCESS",
        payload: (
          <span style={{ color: "green" }}>{res.data.message.extend}</span>
        ),
      });
      setTimeout(() => {
        dispatch({
          type: "EXTEND_EPISODE_SUCCESS",
          payload: null,
        });
      }, 3000);
      func();
      dispatch(getEpisode(id));
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EXTEND_EPISODE_FAIL",
          payload: (
            <span style={{ color: "#ca495d" }}>
              {err.response.data.message.duration}
            </span>
          ),
        });
        setTimeout(() => {
          dispatch({
            type: "EXTEND_EPISODE_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const getNextEpisode = () => async (dispatch) => {
  await axios.get(`${URL}/episode/next`).then((response) => {
    dispatch({
      type: "GET_NEXT_EPISODE",
      next: response.data?.data[0],
    });
  });
};
export const UploadSuccess = (data) => async (dispatch) => {
  dispatch({
    type: "UPLOAD_SUCCESS",
    payload: data,
  });
};

export const getSoftDeletedEpisodes = (dispatch, params) => {
  axios
    .get(`${URL}/episodes/radio/softDeleted`, {
      params: { per_page: params.per_page, page: params.page },
    })
    .then((res) => {
      dispatch({
        type: "SOFT_DELETED_EPISODES",
        payload: res.data.data,
      });
    })
    .catch((err) => {});
};

export const restoreEpisode = (episode_id, dispatch, params) => {
  axios
    .patch(`${URL}/episode/restore/${episode_id}`)
    .then((res) => {
      handleSuccessOne(res.data.message);
      getSoftDeletedEpisodes(dispatch, params);
    })
    .catch((err) => {
      handleErrorOne("error on resotring episode");
    });
};

export const hardDeleteEpisode = (episode_id, dispatch, params) => {
  axios
    .delete(`${URL}/episode/HardDelete/${episode_id}`)
    .then((res) => {
      handleSuccessOne("episode hard deleted successfully");
      getSoftDeletedEpisodes(dispatch, params);
    })
    .catch((err) => {
      handleErrorOne("error on delete episode");
    });
};
export const getLiveWaitingRoom = (params) => async (dispatch) => {
  axios
    .get(`${URL}/episodes/radio/waitingroom?page=${params?.page}`)
    .then((res) => {
      dispatch({
        type: "GET_LIVE_STUDIO",
        data: res.data.data.data,
        totalLives: res.data.data.data.total,
        params,
      });
    });
};
export const updateStatus = (episode_id, status_id) => async (dispatch) => {
  await axios
    .patch(`${URL}/episode/${episode_id}/status`, status_id)
    .then(() => {
      dispatch(
        getLiveWaitingRoom({
          page: 1,
        })
      );
      dispatch(getEpisode(episode_id));
    });
};

//Optimization
export const updateAnimator = (episode_id, animator_id) => async (dispatch) => {
  await axios
    .patch(`${URL}/episode/${episode_id}/animator/${animator_id}`)
    .then(() => {
      dispatch(getEpisode(episode_id));
    });
};
export const updateAnimatorRecurrence =
  (episode_id, recurrence_id, animator_id) => async (dispatch) => {
    await axios
      .patch(
        `${URL}/episode/${recurrence_id}/edit/animator/${animator_id}/recurrence`
      )
      .then(() => {
        dispatch(getEpisode(episode_id));
      });
  };
export const updateColumnist =
  (episode_id, columnist_ids, func) => async (dispatch) => {
    await axios
      .patch(`${URL}/episode/${episode_id}/columnists`, columnist_ids)
      .then(() => {
        dispatch(getEpisode(episode_id));
        func();
      });
  };
export const updateColumnistRecurrence =
  (episode_id, recurrence_id, columnist_ids, func) => async (dispatch) => {
    await axios
      .patch(
        `${URL}/episode/${recurrence_id}/edit/columnists/recurrence`,
        columnist_ids
      )
      .then(() => {
        dispatch(getEpisode(episode_id));
        func();
      });
  };
export const updateGuest =
  (episode_id, guest_ids, func) => async (dispatch) => {
    await axios
      .patch(`${URL}/episode/${episode_id}/guests`, guest_ids)
      .then(() => {
        dispatch(getEpisode(episode_id));
        func();
      });
  };
export const updateGuestRecurrence =
  (episode_id, recurrence_id, guest_ids, func) => async (dispatch) => {
    await axios
      .patch(
        `${URL}/episode/${recurrence_id}/edit/guests/recurrence`,
        guest_ids
      )
      .then(() => {
        dispatch(getEpisode(episode_id));
        func();
      });
  };
export const updateMedias =
  (episode_id, medias_ids, func) => async (dispatch) => {
    await axios
      .patch(`${URL}/episode/${episode_id}/medias`, medias_ids)
      .then(() => {
        dispatch(getEpisode(episode_id));
        func();
      });
  };
export const updateMediasRecurrence =
  (episode_id, recurrence_id, medias_ids, func) => async (dispatch) => {
    await axios
      .patch(
        `${URL}/episode/${recurrence_id}/edit/medias/recurrence`,
        medias_ids
      )
      .then(() => {
        dispatch(getEpisode(episode_id));
        func();
      });
  };
export const updatePlaylists =
  (episode_id, playlist_ids) => async (dispatch) => {
    await axios
      .patch(`${URL}/episode/${episode_id}/playlists`, playlist_ids)
      .then(() => {
        dispatch(getEpisode(episode_id));
      });
  };
export const updatePlaylistsRecurrence =
  (episode_id, recurrence_id, playlist_ids) => async (dispatch) => {
    await axios
      .patch(
        `${URL}/episode/${recurrence_id}/edit/playlists/recurrence`,
        playlist_ids
      )
      .then(() => {
        dispatch(getEpisode(episode_id));
      });
  };
export const updateDuration = (episode_id, duration) => async (dispatch) => {
  await axios
    .put(`${URL}/episode/${episode_id}/edit/durations`, duration)
    .then(() => {
      dispatch(getEpisode(episode_id));
    })
    .catch((err) => {
      if (err.response) {
        handleErrorOne(err.response.data.message);
      }
    });
};
export const updateDurationRecurrence =
  (episode_id, recurrence_id, duration) => async (dispatch) => {
    await axios
      .put(
        `${URL}/episode/${recurrence_id}/edit/durations/recurrence`,
        duration
      )
      .then(() => {
        dispatch(getEpisode(episode_id));
      })
      .catch((err) => {
        if (err.response) {
          handleErrorOne(err.response.data.message);
        }
      });
  };

export const getEpisodesByCategory = (slug, dispatch, page, perPage) => {
  axios
    .get(`${URL}/episodes/category/slug/${slug}/radio/pagination/${perPage}`, {
      params: { page: page },
    })
    .then((res) => {
      dispatch({
        type: "GET_EPISODES_BY_CATEGORY_ID",
        data: res.data.data.data,
      });

      dispatch({
        type: "GET_EPISODES_BY_CATEGORY_SLUG_LASTPAGE",
        lastPage: res.data.data.last_page,
      });
    });
};
export const getEpisodesByTag = (slug, dispatch, currentPage, perPage) => {
  axios
    .get(`${URL}/episodes/tag/slug/${slug}/radio/pagination/${perPage}`, {
      params: { page: currentPage },
    })
    .then((res) => {
      dispatch({
        type: "GET_EPISODES_BY_TAG_ID",
        data: res.data.data.data,
      });

      dispatch({
        type: "GET_EPISODES_BY_TAG_SLUG_LASTPAGE",
        lastPage: res.data.data.last_page,
      });
    });
};
export const getEpisodesByClassifictaion = (slug, dispatch, page, perPage) => {
  axios
    .get(`${URL}/episodes/classification/${slug}/radio/pagination/${perPage}`, {
      params: { page: page },
    })
    .then((res) => {
      dispatch({
        type: "GET_EPISODES_BY_CLASSIFICATION_ID",
        data: res.data.data.data,
      });
      dispatch({
        type: "GET_EPISODES_BY_CATEGORY_SLUG_LASTPAGE",
        lastPage: res.data.data.last_page,
      });
    });
};
export const getClassificationById = async (slug) => {
  const classification = await axios.get(`${URL}/Classification/${slug}`);
  return classification?.data?.data[0];
};

export const getDraftForEpisode = (emission_id, params) => async (dispatch) => {
  await axios
    .get(
      `${URL}/episode/drafts/emission/${emission_id}?per_page=5&page=${params.page}`,
      params
    )
    .then((response) => {
      dispatch({
        type: "GET_DRAFT_EPISODE_ID",
        data: response.data.data,
        params,
      });
    });
};
